import React, { useEffect, useState } from 'react';
import { Provider } from 'react-redux';
import store from './redux/store';
import { BrowserRouter as Router } from 'react-router-dom';
import Views from './views';
import { Routes, Route } from 'react-router-dom';
import { ThemeSwitcherProvider } from 'react-css-theme-switcher';
import {
  THEME_CONFIG,
  WS_URL,
  PRICE_FEED_WS_URL,
  PRICE_FEED_API_KEY,
} from './configs/AppConfig';
import { PriceAdminWebSocketProvider } from './hooks/usePriceAdminWebSocket';
import { PriceFeedWebSocketProvider } from './hooks/usePriceFeedWebSocket';
import Loading from './components/shared-components/Loading';
import ErrorBoundary from './components/shared-components/ErrorBoundary';
import { setToken } from './redux/actions/Auth';

const themes = {
  dark: `${process.env.PUBLIC_URL}/css/dark-theme.css`,
  light: `${process.env.PUBLIC_URL}/css/light-theme.css`,
};

const App = () => {
  const [isStoreReady, setIsStoreReady] = useState(false);
  const [appError, setAppError] = useState(null);

  useEffect(() => {
    try {
      // Initialize authentication state from localStorage
      store.dispatch(setToken());

      const timer = setTimeout(() => {
        setIsStoreReady(true);
      }, 0);

      return () => clearTimeout(timer);
    } catch (error) {
      console.error('Error during app initialization:', error);
      setAppError(error.message || 'Failed to initialize application');
    }
  }, []);

  // Show error state if app failed to initialize
  if (appError) {
    return (
      <div
        className="App"
        style={{
          height: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          flexDirection: 'column',
          padding: '20px',
        }}
      >
        <h2>Application Error</h2>
        <p>Failed to initialize the application: {appError}</p>
        <button onClick={() => window.location.reload()}>Reload Page</button>
      </div>
    );
  }

  if (!isStoreReady) {
    return (
      <div
        className="App"
        style={{
          height: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <Loading cover="page" />
      </div>
    );
  }

  return (
    <ErrorBoundary>
      <div className="App">
        <Provider store={store}>
          <PriceAdminWebSocketProvider socketUrl={WS_URL}>
            <PriceFeedWebSocketProvider
              socketUrl={PRICE_FEED_WS_URL}
              apiKey={PRICE_FEED_API_KEY}
            >
              <ThemeSwitcherProvider
                themeMap={themes}
                defaultTheme={THEME_CONFIG.currentTheme}
                insertionPoint="styles-insertion-point"
              >
                <Router>
                  <Routes>
                    <Route path="/*" element={<Views />} />
                  </Routes>
                </Router>
              </ThemeSwitcherProvider>
            </PriceFeedWebSocketProvider>
          </PriceAdminWebSocketProvider>
        </Provider>
      </div>
    </ErrorBoundary>
  );
};

export default App;
